import React from 'react';
import { Link } from 'react-router-dom';
import { User, Edit2 } from 'lucide-react';

export default function ProfileSection({ user }) {
  const badges = { Emerging: 'text-[#6B7280]', Verified: 'text-[#10B981]', Elite: 'text-[#FF4343]' };
  return (
    <div className="space-y-6" data-testid="profile-section">
      <div className="bg-[#111827] border border-white/10 p-4 sm:p-8 border-l-[3px] border-l-[#FF4343]">
        <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6">
          <div className="flex items-start gap-4 sm:gap-6 w-full sm:w-auto">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#1F2937] border border-white/10 flex-shrink-0 overflow-hidden">
              {user.headshot_url ? <img src={user.headshot_url} alt="" className="w-full h-full object-cover" /> : <User className="w-8 h-8 text-[#6B7280] m-auto mt-4 sm:mt-6" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 sm:gap-3 mb-1 flex-wrap">
                <h2 className="font-display text-xl sm:text-2xl font-bold">{user.name}</h2>
                <span className={`text-xs font-mono uppercase tracking-wider ${badges[user.badge_level] || 'text-[#6B7280]'}`}>
                  {user.badge_level}
                </span>
              </div>
              <p className="text-[#9CA3AF] text-xs sm:text-sm mb-1 sm:mb-2">{user.headline}</p>
              <p className="text-[#6B7280] text-xs sm:text-sm hidden sm:block">{user.bio}</p>
            </div>
          </div>
          <Link to="/onboarding" data-testid="edit-profile-btn" className="border border-white/20 text-white hover:bg-white/5 px-4 py-2 text-xs sm:text-sm flex items-center gap-2 transition-colors flex-shrink-0 w-full sm:w-auto justify-center sm:justify-start">
            <Edit2 className="w-3 h-3" /> Edit Profile
          </Link>
        </div>
        <p className="text-[#6B7280] text-xs mt-3 sm:hidden">{user.bio}</p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { label: 'Trust Score', value: user.trust_score || 0, color: 'text-[#FF4343]' },
          { label: 'LinkedIn', value: user.linkedin_connections?.toLocaleString() || '0', color: 'text-white' },
          { label: 'Industries', value: user.industries?.length || 0, color: 'text-white' },
          { label: 'Status', value: user.status, color: user.status === 'approved' ? 'text-[#10B981]' : 'text-[#FF4343]' },
        ].map((s, i) => (
          <div key={i} className="bg-[#111827] border border-white/10 p-3 sm:p-4 text-center min-w-0">
            <span className={`block font-mono text-xl sm:text-2xl font-bold tabular-nums leading-tight truncate ${s.color}`}>{s.value}</span>
            <p className="text-[10px] sm:text-xs text-[#6B7280] font-mono uppercase tracking-wider mt-1 truncate">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

